// Test id wartości na karcie pojedynczego lokalu w RP (kafelki na szczegółach inwestycji, w promocjach, w panelach oferty na mapie i w modalu oferty). Jeden klucz oznacza rolę wartości, a nie jeden element w całym DOM: karta każdego lokalu ma własny węzeł, więc kopii jest tyle, ile kart. Test najpierw wskazuje właściciela listy (sekcja, dialog), potem kartę, dopiero w niej wartość.

export const PROPERTY_CARD_TEST_ID = {
    // Metraż lokalu (np. „28,53 m²”), sam tekst wartości bez etykiety „Metraż”. Nie dotyczy zakresów inwestycji, powierzchni działki, balkonu ani pomieszczeń.
    AREA: "property-card-area",

    // Piętro lokalu: liczba, „parter” albo, w ofercie domów, liczba pięter. To jeden widoczny slot karty zależny od typu oferty. Nie dotyczy kondygnacji budynku inwestycji ani osobnej pozycji „poziomy” w szczegółach lokalu.
    FLOOR: "property-card-floor",

    // Liczba pokoi lokalu, sam tekst wartości bez etykiety „Pokoje”.
    ROOMS: "property-card-rooms"
};
// Test id wartości na karcie pojedynczego lokalu w RP (kafelki na szczegółach inwestycji, w promocjach, w panelach oferty na mapie i w modalu oferty). Jeden klucz oznacza rolę wartości, a nie jeden element w całym DOM: karta każdego lokalu ma własny węzeł, więc kopii jest tyle, ile kart. Test najpierw wskazuje właściciela listy (sekcja, dialog), potem kartę, dopiero w niej wartość.

export const PROPERTY_CARD_TEST_ID = {
    // Metraż lokalu (np. „28,53 m²”), sam tekst wartości bez etykiety „Metraż”. Nie dotyczy zakresów inwestycji, powierzchni działki, balkonu ani pomieszczeń.
    AREA: "property-card-area",

    // Piętro lokalu: liczba, „parter” albo, w ofercie domów, liczba pięter. To jeden widoczny slot karty zależny od typu oferty. Nie dotyczy kondygnacji budynku inwestycji ani osobnej pozycji „poziomy” w szczegółach lokalu.
    FLOOR: "property-card-floor",

    // Liczba pokoi lokalu, sam tekst wartości bez etykiety „Pokoje”.
    ROOMS: "property-card-rooms"
};
